import React, { useMemo } from 'react';

// helpers
import { RoutePaths } from 'routes/routes';
import { StateModel } from 'redux/reducers';
import { useSelector } from 'react-redux';
import { StateModel as IntakeFormStateModel } from 'redux/reducers/intakeForm';
import { StateModel as ApplicationsStateModel } from 'redux/reducers/applications';
import {
  getActiveApplicationId,
  getActiveIntakeFormId,
} from 'helpers/localStorageHelpers';

// components
import { Navigate } from 'react-router-dom';

const withApplications = () => (Component: any) => {
  const WithApplications = () => {
    const { applications, activeApplication } = useSelector<
      StateModel,
      ApplicationsStateModel
    >((state) => state.applications);

    const { intakeForm, intakeSubmissions } = useSelector<
      StateModel,
      IntakeFormStateModel
    >((state) => state.intakeForm);

    const showSelectScreen = useMemo(() => {
      const applicationsCount = applications?.length || 0;
      const intakeSubmissionsCount = intakeSubmissions.length;

      const activeIntakeFormId = getActiveIntakeFormId();
      const activeApplicationId = getActiveApplicationId();

      return (
        applicationsCount + intakeSubmissionsCount > 1 &&
        !activeApplication &&
        !activeApplicationId &&
        !activeIntakeFormId &&
        !intakeForm
      );
    }, [intakeForm, intakeSubmissions, applications, activeApplication]);

    if (location.pathname === RoutePaths.SelectAccessContextPage) {
      return showSelectScreen ? (
        <Component />
      ) : (
        <Navigate to={RoutePaths.Root} />
      );
    } else if (showSelectScreen) {
      return <Navigate to={RoutePaths.SelectAccessContextPage} />;
    }

    return <Component />;
  };

  return WithApplications;
};

export default withApplications;
